import { Link, LinkType } from 'types/Link';

export const ADMIN_LINK_CHANNEL_KEY = '*';
export const NO_LINK_SELECTED = 'inactif';

export const isSelfLink = (link?: Link): boolean =>
  link?.type === LinkType.SELF;

export const linkHasAdminAccess = (link: Link | undefined): boolean =>
  !!link?.isAdmin;